module.exports = __webpack_public_path__ + "img/ec91d43.png";